class AlertStockLevelGridTemplate {

  alert;

  constructor(alert) {
    this.alert = alert;
  }

  columns = [
    {
      Header: "Referência",
      accessor: "stockHistory.productType.reference"
    },
    {
      Header: "Name",
      accessor: "stockHistory.productType.friendlyName"
    },
    {
      Header: "Local",
      accessor: "stockHistory.bizLocation.friendlyName"
    },
    {
      Header: "Segurança",
      accessor: "stockHistory.quantitySecure"
    },
    {
      Header: "Quantidade",
      accessor: "stockHistory.quantity",
      Cell: row => (row.original.stockHistory.quantity / row.original.stockHistory.quantitySecure).toFixed(2) + "%"
    }
  ];

  endpoint = () => `alerts/v1/alerts-details/alerts/${this.alert.id}/STOCK_LEVEL_DETAIL`
}

export {AlertStockLevelGridTemplate}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/StockLevelAlert/AlertStockLevelGridTemplate.js